module.exports = __webpack_public_path__ + "img/wheel_HIGH_lose.6de231b0.png";